import { DiaryFormElementMessageTranslation } from "./diary-form-element-message-translation.model";

export class DiaryFormElementMessage {
  id: string;
  elementId: string;
  active: boolean = false;
  showInSummary: boolean = false;
  style: string;
  operator: number | null = null;
  patientChoice: string;
  translations: DiaryFormElementMessageTranslation[] = [];

  constructor(init?: Partial<DiaryFormElementMessage>) {
    Object.assign(this, init);

    // Deep clone translations array
    if (init?.translations && init.translations.length > 0) {
      this.translations = init.translations.map(t => new DiaryFormElementMessageTranslation(t));
    }
  }
}
